import { ACTION_CREATE, ACTION_DETAILS } from "models/role/action";
import {
  SUBJECT_CASH_MANAGEMENT,
  SUBJECT_PAYOUTS_NOTIFICATIONS,
} from "models/role/subject";
import { useConnectBreadcrumbs } from "modules/connect";
import { Page404 } from "pages/Page404";
import { lazyRetry } from "utils/lazyRetry";

import { withBreadcrumbs } from "../../common/hoc/withBreadcrumbs";
import { PAGE_URLS } from "../constants/PageUrls";
import { accountRoutes } from "./account";
import { providerCustomerConfigRoutes } from "./providerCustomerConfig";

import type { Route } from "routes/RouteModel";

const CashManagement = lazyRetry(
  () => import("../pages/Details"),
  "CashManagement"
);
const NotificationsSettingsEdit = lazyRetry(
  () => import("../pages/NotificationsSettingsEdit"),
  "CashManagementNotifications"
);

const PayoutNotificationsSettingsEdit = lazyRetry(
  () =>
    import("../components/payout-notifications/PayoutNotificationsEditCreate"),
  "PayoutNotificationsSettingsEdit"
);

const NotFound = withBreadcrumbs(Page404, useConnectBreadcrumbs);

export const cashManagementRoutes: Route[] = [
  {
    i18nName: "Cash management",
    path: PAGE_URLS.details,
    component: CashManagement,
    can: {
      do: ACTION_DETAILS,
      on: SUBJECT_CASH_MANAGEMENT,
    },
  },
  {
    i18nName: "Cash management",
    path: PAGE_URLS.payoutNotifications,
    component: PayoutNotificationsSettingsEdit,
    can: {
      do: ACTION_CREATE,
      on: SUBJECT_PAYOUTS_NOTIFICATIONS,
    },
    newTheme: true,
  },
  ...accountRoutes,
  ...providerCustomerConfigRoutes,
  {
    i18nName: "Edit notifications settings - Cash management",
    path: PAGE_URLS.notifications,
    component: NotificationsSettingsEdit,
    newTheme: true,
  },
  {
    i18nName: "Not found",
    path: "*",
    component: NotFound,
    newTheme: true,
  },
];
